<template>
    <div class="user">
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="major.major_name" label="报考专业" align="center"></el-table-column>
                    <el-table-column prop="company" label="单位名称" align="center"></el-table-column>
                    <el-table-column prop="status" label="报考状态" width="200" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status.value == 0">未审核</span>
                            <span class="red" v-if="scope.row.status.value == 10">未通过</span>
                            <span class="green" v-if="scope.row.status.value == 20">已通过</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="报考时间" align="center"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="130" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" v-if="scope.row.status.value == 10" @click="goDetail(scope.row)">进入维护</el-button>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="curPage"
                        :page-size="pageSize" layout="total, prev, pager, next, jumper"
                        :total="totalDataNumber">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import SignApi from '@/api/sign.js';
    import { getCookie } from '@/utils/base.js';

    export default {
        data() {
            return {
                activeName: 'all',
                // 是否加载完成
                loading: true,
                // 列表数据
                tableData: [],
                // 一页多少条
                pageSize: 20,
                // 一共多少条数据
                totalDataNumber: 0,
                // 当前是第几页
                curPage: 1,
                // 搜索条件
                searchForm: {},
            };
        },
        created() {
            // 获取列表
            this.getTableList();
        },
        methods: {
            // 获取列表
            getTableList() {
                let that = this;

                let Params = that.searchForm;
                Params.dataType = that.activeName
                Params.token = getCookie('token_supplier')
                Params.page = that.curPage;
                Params.list_rows = that.pageSize;
                that.loading = true;

                SignApi.getMySignList(Params, true)
                    .then(res => {
                        that.loading = false;
                        that.tableData = res.data.list.data;
                        that.totalDataNumber = res.data.list.total
                    })
                    .catch(error => {

                    });
            },

            // 选择第几页
            handleCurrentChange(val) {
                let that = this;
                that.curPage = val;
                that.loading = true;
                that.getTableList();
            },

            // 每页多少条
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            // 进入维护
            goDetail(row){
                this.$router.push({
                    path: "/mysign/detail",
                    query: {
                        sign_id: row.sign_id
                    }
                });
            }

        }
    };
</script>

<style lang="scss" scoped>
    .el-form-item{
        margin-bottom: 25px;
    }
    .common-button-wrapper{
        bottom: 70px;
        background: transparent;
    }

    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
        cursor: pointer;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/views/mysign/index.vue